/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_TitleInputs */

const en_audit_title = /** @type {(inputs: Audit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit Logs`)
};

const pt_br2_audit_title = /** @type {(inputs: Audit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logs de auditoria`)
};

/**
* | output |
* | --- |
* | "Audit Logs" |
*
* @param {Audit_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_title = /** @type {((inputs?: Audit_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_title(inputs)
	return pt_br2_audit_title(inputs)
});